import React from "react";

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';


import gasLeak  from "../images/gas_leak.svg";
import gasNoLeak  from "../images/gas_no_leak.svg";

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

const GasLeak = ({ value, title, desc, status, disabled }) => {
    if(status === "true")
    {
        return (
           <Disabled disabled={disabled}>
              <Stack direction="column" align="left" spacing={1}>
              <img
                      src={gasLeak}
                      alt={title}
                      loading="lazy"
                      style={
                        {
                          width: 120,
                          height: "100%",
                        }
                      }
                    />
                    <Typography style={{marginTop: 10}} variant="caption" gutterBottom component="div">
                      {desc}
                    </Typography>
                  <Typography style={{marginBottom: 75}} variant="subtitle2" gutterBottom component="div">
                    {value}%
                  </Typography>
                  </Stack>
            </Disabled>
          );
    }
    else
    {
        return (
          <Disabled disabled={disabled}>
            <Stack direction="column" align="left" spacing={1}>
              <img
                        src={gasNoLeak}
                        alt={title}
                        loading="lazy"
                        style={
                          {
                            width: 120,
                            height: "100%",
                          }
                        }
                      />
                      <Typography variant="caption" gutterBottom component="div">
                        {desc}
                      </Typography>
                    <Typography style={{marginBottom: 55}} variant="subtitle2" gutterBottom component="div">
                      {value}%
                    </Typography>
              </Stack>
            </Disabled>
          );
    }
  
};

export default GasLeak;
